import { render, staticRenderFns } from "./AttachList.vue?vue&type=template&id=2aa2f737&"
import script from "./AttachList.vue?vue&type=script&lang=js&"
export * from "./AttachList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports